export const DURATION_OPTIONS = [
  { value: 600, label: '10 mins' },
  { value: 900, label: '15 mins' },
  { value: 1800, label: '30 mins' },
];

export const EMPTY_MESSAGE = 'No text provided';
